import React, { useState } from 'react';
import '../styles/FAQ.css';

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: 'How does AI resume screening work?',
      answer:
        "FortIf uses advanced natural language processing and machine learning to analyze resumes and job descriptions. Our AI extracts key information like skills, experience, and education, then intelligently matches candidates to job requirements. Unlike simple keyword matching, our system understands context, skill relationships, and career progression patterns to provide accurate match scores.",
    },
    {
      question: 'Is the screening process bias-free?',
      answer:
        'Yes, FortIf is designed with fairness at its core. Our blind resume mode can hide personal identifiers like names, gender, and educational institutions. We provide fairness metrics dashboards and comply with EEOC (US), GDPR, and India hiring norms. Every decision is explainable, and our AI is regularly audited to minimize algorithmic bias.',
    },
    {
      question: 'What file formats do you support?',
      answer:
        'FortIf supports all common resume formats including PDF, DOC, DOCX, and TXT files. Our advanced parsing technology can handle multiple languages and various resume layouts. We also support bulk uploads for high-volume screening scenarios.',
    },
    {
      question: 'How long does it take to screen resumes?',
      answer:
        "Resume screening with FortIf is nearly instantaneous. Individual resumes are processed in under 2 seconds, and you can screen thousands of resumes simultaneously in minutes. The system provides real-time match scores, rankings, and candidate summaries, dramatically reducing your time-to-hire.",
    },
    {
      question: 'Can I integrate FortIf with my existing ATS?',
      answer:
        'Absolutely! FortIf integrates seamlessly with popular ATS platforms including Greenhouse, Lever, Workday, and Zoho Recruit. We also offer a flexible API for custom integrations with proprietary systems. Our team will help you set up the integration during onboarding.',
    },
    {
      question: 'Is my data secure and compliant?',
      answer:
        "Data security and compliance are our top priorities. FortIf is GDPR compliant, SOC 2 certified, and follows industry best practices for data encryption and storage. All candidate data is encrypted at rest and in transit. We never share your data with third parties, and you maintain full ownership and control of all information processed through our platform.",
    },
    {
      question: 'What makes FortIf different from competitors?',
      answer:
        'FortIf stands out through contextual skill understanding (not just keyword matching), explainable AI that shows why each candidate was scored a certain way, and advanced features like Resume vs Reality verification and predictive hiring analytics. Our focus on transparency, bias reduction, and recruiter productivity sets us apart from generic screening tools.',
    },
    {
      question: 'Do you offer a free trial?',
      answer:
        'Yes! We offer a 14-day free trial for all new users. No credit card is required to start your trial. You can test all core features including AI resume parsing, match scoring, and bulk screening. Our team is available to help you get the most out of your trial period.',
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq section">
      <div className="container">
        {/* Section Header */}
        <div className="section-header text-center">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">
            Everything you need to know about FortIf. Can't find an answer? Reach out to our team.
          </p>
        </div>

        {/* FAQ Grid */}
        <div className="faq-grid">
          {faqs.map((faq, index) => (
            <div key={index} className={`faq-item ${activeIndex === index ? 'active' : ''}`}>
              <button className="faq-question" onClick={() => toggleFAQ(index)}>
                <span className="question-text">{faq.question}</span>
                <span className="faq-icon">{activeIndex === index ? '−' : '+'}</span>
              </button>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="faq-cta text-center">
          <h3>Still have questions?</h3>
          <p>Our team is here to help you find the perfect solution for your hiring needs.</p>
          <a href="#footer" className="btn btn-primary btn-large">
            Contact Support
          </a>
        </div>
      </div>
    </section>
  );
}

export default FAQ;
